
import { TQuizProps } from "../type";
import { QuizMaster } from "../master";
export function QuizSmirnoff(props: TQuizProps) {
    return <QuizMaster {...props} />
}